"use strict";
/**
 * This file serves as a central location for all Lit node endpoints and their request/response interfaces & types.
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=node-interfaces.js.map